module.exports = __webpack_public_path__ + "static/icon-style-4250f093ef37e4a698cd05d826cb78ef.svg";